import { Component } from '@angular/core';

@Component({
  templateUrl: './expired-invite.page.html',
})
/**
 * Expired invite page!
 */
export class ExpiredInvitePage {}
